export {
  dateFormat,
  getParentPageTitle,
  getIconByType,
  useDOMParser,
  insertTitlesAttributesToHtml,
} from './utils';
